import React from "react";
import { useContext, useRef } from "react";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";
import { useEffect, useState } from "react";

import { useHistory } from "react-router";
export default function Registo() {
  const PS = process.env.REACT_APP_PUBLIC_SERVER;
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const [loader, setloader] = useState(false);

  const tel = useRef();
  const username = useRef();
  const email = useRef();
  const password = useRef();
  const passwordagain = useRef();
  const tipo = useRef();

  const history = useHistory();

  const handleClick = async (e) => {
    setloader(!loader);
    e.preventDefault();
    if (passwordagain.current.value !== password.current.value) {
      passwordagain.current.setCustomValidity("senhas não correspondem");
      setloader(!loader);
    } else {
      const user = {
        Tel: tel.current.value,
        email: email.current.value,
        username: username.current.value,
        password: password.current.value,
        tipo: tipo.current.value,
      };
      try {
        await axios.post("auth/registrar", user);
        window.location.assign(PF + "verificaremail" + email.current.value);
      } catch (err) {
        console.log(err);
        setloader(!loader);
        alert("Acorreu um erro tente novamente!");
      }
    }
  };

  return (
    <>
      <div className="auth-fluid">
        <div className="auth-fluid-form-box">
          <div className="align-items-center d-flex h-100">
            <div className="card-body">
              <div className="auth-brand text-center text-lg-start">
                <a href="index.html" className="logo-light">
                  <span>
                    <img
                      src={PS + "logo.png"}
                      alt=""
                      height="80"
                      style={{ marginTop: "-40px", marginLeft: "-60px" }}
                    />
                  </span>
                </a>
              </div>

              <form onSubmit={handleClick}>
                <div>
                  <h4 className="mt-0 text-center">
                    <i className="uil uil-user-plus"></i> Registro
                  </h4>
                  <div className="mb-3">
                    <label for="fullname" className="form-label">
                      Nome Completo
                    </label>
                    <input
                      required
                      minlength="5"
                      ref={username}
                      className="form-control"
                      type="text"
                      name="nome"
                      placeholder="Digite seu nome completo"
                    />
                  </div>
                  <div className="mb-3">
                    <label for="emailaddress" className="form-label">
                      Email
                    </label>
                    <input
                      className="form-control"
                      name="email"
                      type="email"
                      ref={email}
                      required
                      placeholder="Digite seu email"
                    />
                  </div>
                  <div className="mb-3">
                    <label for="Tel" className="form-label">
                      Tel
                    </label>
                    <input
                      name="tel"
                      ref={tel}
                      className="form-control"
                      type="number"
                      required
                      placeholder="Digite seu Nº de telefone"
                    />
                  </div>
                  <div className="mb-3">
                    <label for="Tel" className="form-label">
                      Tipo de Pessoa
                    </label>
                    <select
                      ref={tipo}
                      defaultValue={"Individual"}
                      className="form-control"
                    >
                      <option value="Individual">Individual</option>
                      <option value="Colectivo">Colectivo</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label for="password" className="form-label">
                      Senha
                    </label>
                    <input
                      name="senha"
                      className="form-control"
                      type="password"
                      required
                      ref={password}
                      id="password"
                      minLength="6"
                      placeholder="Digite uma senha"
                    />
                  </div>
                  <div className="mb-3">
                    <label for="password" className="form-label">
                      Confirmar Senha
                    </label>
                    <input
                      name="user"
                      className="form-control"
                      ref={passwordagain}
                      type="password"
                      required
                      id="password"
                      placeholder="Digite sua senha novamente"
                    />
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="mb-0 d-grid text-center">
                        {loader ? (
                          <button className="btn btn-success btn-rounded">
                            <CircularProgress color="green" size="22px" />
                          </button>
                        ) : (
                          <button
                            className="btn btn-success btn-rounded"
                            type="submit"
                          >
                            Registrar <i className="mdi mdi-account-check"></i>
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mb-0 d-grid text-center">
                        <a href="login" className="btn btn-primary btn-rounded">
                          Login <i className="mdi mdi-account"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="auth-fluid-right text-center">
          <div className="auth-user-testimonial">
            <h2 className="mb-3">EmaInvest!</h2>
            <p className="lead">
              <i className="mdi mdi-format-quote-open"></i> Se você quer ficar
              rico, lembre-se de que a maneira de fazer isso é por meio de
              patrimônio, não de salário.{" "}
              <i className="mdi mdi-format-quote-close"></i>
            </p>
            <p>- Sam Altman</p>
          </div>
        </div>
      </div>
      ;
    </>
  );
}
